import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEnvelope,
    faLocationDot,
    faPhone,
    faClock,
} from "@fortawesome/free-solid-svg-icons";
import templateStyles from "../../contact-template.module.css";
import styles from './info.module.css';

const Info = () => {
    return (
        <div className={styles.flex_item}>

            <p className={styles.contact_item}>
                <FontAwesomeIcon icon={faPhone} className={styles.icon}/>
                <a href="tel:438-883-6890" className="phone-link" style={{color:"black"}}>438-883-6890
                </a>
            </p>
            <p className={styles.contact_item}>
                <FontAwesomeIcon icon={faEnvelope} className={styles.icon}/>
                info.garderielabelleetoile@gmail.com
            </p>
            <p className={styles.contact_item}>
                <FontAwesomeIcon icon={faLocationDot} className={styles.icon}/>
                Av. Jean-Baptiste-Varin, La Prairie, QC J5R 6T8
            </p>
        </div>
    );
};

export default Info;
